import {Task} from "v2/api/Records";

export const apiTask = (task) => {
  return new Task(task);
};

export default {
  apiTask,
};



/** WEBPACK FOOTER **
 ** ./src/app/v2/api/Tasks.js
 **/